/* ============================================================================
   WWF-CUSTOM FILE | CL-052 | Added 2026-10-17 | Wild + Well-Fed rebrand
   ----------------------------------------------------------------------------
   Wholesale (B2B) quantity rules for the +/- buttons.

   Why: Palo Alto's quantity counter always adds or removes 1. Wholesale
   products sell in a minimum of 12 and steps of 12, so + from 12 went to 13,
   Shopify rejected it, and the cart showed "Sorry, looks like we don't have
   enough of this product."

   What it does:
     - Product page and Quick view: the quantity field already has min and
       step from Shopify's quantity rules; +/- now move by that step.
     - Cart drawer and cart page: snippets/cart-line-items.liquid (CL-052
       marker) adds min and data-wwf-step to each line's field; +/- move by
       the step, and - at the minimum removes the line (same as the theme).
     - Shows the theme's hidden "multiples of / minimum of" note on the
       product page when a rule applies.
   Retail products (step 1) are untouched: the theme handles them as before.
   ========================================================================= */
(function () {
  'use strict';

  function stepOf(field) {
    var s = Number(field.getAttribute('data-wwf-step') || field.getAttribute('step') || 1);
    return s > 1 ? s : 1;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (!btn) return;
    var counter = btn.closest('quantity-counter');
    var field = counter && counter.querySelector('[data-quantity-field]');
    if (!field) return;
    var step = stepOf(field);
    if (step === 1) return; // retail: let the theme handle it

    e.preventDefault();
    e.stopImmediatePropagation();

    var min = Number(field.getAttribute('min') || 0);
    var max = Number(field.getAttribute('max') || 0) || null;
    var inCart = !!counter.closest('[data-cart-item]');
    var cur = Number(field.value || 0);
    var next;

    if (btn.matches('[data-quantity-plus]')) {
      next = cur < min ? min : Math.floor(cur / step) * step + step;
      if (max !== null && next > max) next = Math.floor(max / step) * step;
    } else {
      next = Math.ceil(cur / step) * step - step;
      if (next < min) next = inCart ? 0 : min; // cart: remove; product page: stay at minimum
    }
    if (next === cur) return;

    counter.quantityValue = next;
    if (typeof counter.updateQuantity === 'function') counter.updateQuantity();
    else { field.value = next; field.dispatchEvent(new Event('change', { bubbles: true })); }
  }, true);

  /* WWF-CUSTOM CL-063 | 2026-10-18 | Typed quantities (OPEN-079): a number
     typed into a wholesale quantity field is rounded up to the next valid
     step (and at least the minimum) before the theme or Shopify sees it, so
     13 becomes 24 instead of showing the "not enough of this product" error.
     In the cart, 0 still removes the line. Runs in the capture phase. */
  function fixTyped(e) {
    var field = e.target;
    if (!field || !field.matches || !field.matches('[data-quantity-field]')) return;
    var step = stepOf(field);
    if (step === 1) return;
    var min = Number(field.getAttribute('min') || 0);
    var max = Number(field.getAttribute('max') || 0) || null;
    var inCart = !!field.closest('[data-cart-item]');
    var cur = Math.max(0, Math.floor(Number(field.value) || 0));
    var next;
    if (cur === 0 && inCart) next = 0;
    else {
      next = Math.ceil(cur / step) * step;
      if (next < min) next = Math.ceil(min / step) * step;
      if (max !== null && next > max) next = Math.floor(max / step) * step;
    }
    if (String(next) !== String(field.value)) {
      field.value = next;
      var counter = field.closest('quantity-counter');
      if (counter) counter.quantityValue = next;
    }
  }
  document.addEventListener('change', fixTyped, true);
  document.addEventListener('blur', fixTyped, true);

  function showRules() {
    document.querySelectorAll('[data-quantity-rules].hidden').forEach(function (el) {
      if (el.textContent.replace(/\s+/g, '')) el.classList.remove('hidden');
    });
  }
  if (document.readyState !== 'loading') showRules();
  else document.addEventListener('DOMContentLoaded', showRules);
  new MutationObserver(function () { showRules(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
